// store.js
import { configureStore } from '@reduxjs/toolkit';
import webUtilitiesSlice from './features/webUtilitiesSlice';

export const store = configureStore({
  reducer: {
    webUtilities: webUtilitiesSlice,
  },
});
